<template>
  <div>
    <div class="modal-wrapper no-print"
         :class="[{'js-no-close': appendToBody}, {'modal-wrapper--from-top': placeInTop}]"
         ref="d_modal"
         @click.self="$emit('close')">
      <div class="modal" :style="{ top: !placeInTop ? '0px' : pxFromTop + 'rem' }">
        <div class="close-cross" v-if="showClose" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
        <slot name="insertComponent">
          <h2>Hello</h2>
        </slot>
      </div>
      <div class="bg-overlay animateFast fadeIn" v-if="isBgOverlay" @click.stop.self="$emit('close')"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showClose: {
      type: Boolean,
      default: true
    },
    isBgOverlay: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    placeInTop: {
      type: Boolean,
      default: false
    },
    pxFromTop: {
      type: Number,
      default: 2
    },
    isCloseOnEsc: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleKeydown (event) {
      if (event.key === 'Escape' && this.isCloseOnEsc) {
        this.$emit('close')
      }
    }
  },
  mounted () {
    if (this.appendToBody) {
      const el = this.$refs.d_modal
      const container = document.getElementById('djs-content-container')

      if (el && container) {
        container.appendChild(el)
      }
    }
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy () {
    const el = this.$refs.d_modal
    if (el && el.parentNode) {
      el.parentNode.removeChild(el)
    }
    window.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>

<style scoped>
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  position: relative;
  z-index: 9999;
  background: #f6f9fc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  animation-name: fadeUp;
  animation-duration: 0.25s;
}

.modal-wrapper--from-top .modal {
  position: absolute;
  top: 2rem;
}

.modal__close {
  cursor: pointer;
  color: #ffffff;
}

.close-cross {
  position: absolute;
  color: #ffffff;
  top: -1.5rem;
  right: 0rem;
  cursor: pointer;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
}

.d-modal__header {
  background: #fff;
  padding: 1rem;
  overflow: hidden;
  border-radius: 4px 4px 0 0;
  color: #3d4340;
  border-bottom: 1px solid #d8d8d8;
  text-align: center;
  position: relative;
}

.d-modal__header__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 1;
  font-size: 1.2rem;
  opacity: 0.85;
}

.d-modal__body {
  width: 400px;
  padding: 1rem 2rem;
}
</style>



// WEBPACK FOOTER //
// DModal.vue?6e78e032